import { z } from 'zod';
import { healthcardSchema } from './healthcard';

import { basePatientSchema } from './basePatient';
import { claimSchema } from './claim';
import { claimHistoriesSchema } from './claimHistory';

export const patientSchema = basePatientSchema.extend({
  healthcards: z
    .lazy(() => healthcardSchema.array())
    .optional()
    .nullable(),
  claims: z
    .lazy(() => claimSchema.array())
    .optional()
    .nullable(),
  claimHistories: z
    .lazy(() => claimHistoriesSchema.array())
    .optional()
    .nullable(),
});

export const formatPatientName = (
  firstName: string,
  lastName: string
): string => {
  return `${lastName}, ${firstName}`;
};
